// 引数で受け取ったオブジェクトに要素の表示・非表示イベントを登録する。
class inOutViewEventDispatcher {

  constructor(target) {
    this.isDisplay = false;
    this.scrollTop = $(window).scrollTop();
    this.regist(target);
  }

  regist(target) {
    $(window).on('load scroll', () => {
      const scrollBottom = $(window).scrollTop() + $(window).height();
      const isScrollToBottom = this.scrollTop < $(window).scrollTop();
      const isInView = target.offset().top <= scrollBottom;

      if(!this.isDisplay && isInView && isScrollToBottom) {
        this.isDisplay = true;
        target.trigger('inViewFromBottom');
      }

      if (this.isDisplay && !isInView && !isScrollToBottom) {
        this.isDisplay = false;
        target.trigger('outViewToBottom');
      }

      this.scrollTop = $(window).scrollTop();
    });
  }
}

const affectIsActive = (targets, method) => {
  if (targets === undefined) {
    return;
  }
  if (!Array.isArray(targets)) {
    targets = [targets];
  }
  const methodName = method + 'Class';
  targets.forEach((target) => {
    $(target)[methodName]('is-active');
  });
};

$(() => {
  // 要素が表示されたとき、targetに指定された要素を表示する。
  $('.js-toggleIsActiveOnShow').each((index, self) => {
    const eventDispatcher = new inOutViewEventDispatcher($(self));

    let selectors = $(self).data('target');
    if (!Array.isArray(selectors)) {
      selectors = [selectors];
    }

    selectors.forEach((selector) => {
      $(self).on({
        inViewFromBottom: () => {
          affectIsActive(selector, 'add');
        },
        outViewToBottom: () => {
          affectIsActive(selector, 'remove');
        },
      });
    });
  });

  // 要素が非表示になったとき、targetに指定された要素を表示する。
  $('.js-toggleIsActiveOnHide').each((index, self) => {
    const eventDispatcher = new inOutViewEventDispatcher($(self));

    let selectors = $(self).data('target');
    if (!Array.isArray(selectors)) {
      selectors = [selectors];
    }

    selectors.forEach((selector) => {
      $(self).on({
        inViewFromBottom: () => {
          affectIsActive(selector, 'remove');
        },
        outViewToBottom: () => {
          affectIsActive(selector, 'add');
        },
      });
    });
  });

  // targetで指定された要素がisActiveならoffにして削除
  $('.js-isActiveRemove').on('click', (self) => {
    const target = $(self.currentTarget).data('target');
    if (target === undefined) {
      return;
    }

    $(target).on('transitionend webkitTransitionEnd', () => {
      $(target).remove();
    });

    affectIsActive(target, 'remove');
  });
});
